import { GridColDef } from '@mui/x-data-grid';
import lang from '../../../languages/en.json';
import { isMobileDevice } from '../../../utils/appUtils';
import { createKpiRenderers, renderValueOrRisk, GridRenderContext } from '../cellRenderers';

/**
 * Creates column definitions for Focus Area DataGrid
 * This demonstrates reusing renderers for a different grid type
 */
export const createFocusAreaColumns = (context: GridRenderContext): GridColDef[] => {
  const renderers = createKpiRenderers(context);

  return [
    {
      field: 'focusArea',
      headerName: lang.dataGrid.columns.focusArea,
      flex: 2,
      minWidth: 200,
      align: 'left',
      headerAlign: 'left',
    },
    {
      field: 'kpiGoal',
      headerName: lang.dataGrid.columns.goal,
      flex: 1,
      minWidth: 120,
      align: 'left',
      headerAlign: 'left',
      renderCell: params => renderValueOrRisk(params, params.row.kpiGoal),
    },
    ...(!isMobileDevice()
      ? ([
          {
            field: 'takeActionTitle',
            headerName: lang.pageContent.columnTakeAction,
            flex: 2,
            minWidth: 150,
            renderCell: renderers.renderTakeActionCell,
            align: 'left' as const,
            headerAlign: 'left' as const,
          },
        ] as GridColDef[])
      : []),
    {
      field: 'acceptance',
      headerName: lang.dataGrid.columns.acceptance,
      flex: 1,
      minWidth: 120,
      align: 'left',
      headerAlign: 'left',
      renderCell: params => renderValueOrRisk(params, params.row.acceptance),
    },
  ];
};
